import React from 'react';
import { Link } from '@inertiajs/react';
import AdminLayout from '../../layouts/AdminLayout';
import DataTable, { type Column } from '../../components/admin/DataTable';
import FilterBar from '../../components/admin/FilterBar';
import { day, since } from '../../components/admin/format';

type Row = {
  id: number;
  email: string;
  name: string | null;
  created_at: string;
  tasks_count: number;
  pomodoros_count: number;
  worklogs_count: number;
  wiki_pages_count: number;
  last_seen_at: string | null;
};

type UsersProps = { users: Row[]; q: string; page: number; per: number; total: number };
type UsersComponent = React.FC<UsersProps> & {
  layout?: (page: React.ReactNode) => React.ReactNode;
};

const COLUMNS: Column<Row>[] = [
  { key: 'id', header: 'ID', width: '52px', align: 'right', mono: true, render: (r) => r.id },
  {
    key: 'email',
    header: '邮箱',
    truncate: true,
    render: (r) => (
      <Link href={`/admin/users/${r.id}`} className="text-admin-accent hover:underline">
        {r.email}
      </Link>
    ),
  },
  { key: 'name', header: '名称', width: '120px', truncate: true, render: (r) => r.name ?? '—' },
  { key: 'created', header: '注册', width: '106px', render: (r) => day(r.created_at) },
  { key: 'tasks', header: '任务', width: '64px', align: 'right', render: (r) => r.tasks_count },
  { key: 'pomo', header: '番茄', width: '64px', align: 'right', render: (r) => r.pomodoros_count },
  { key: 'wl', header: 'Worklog', width: '74px', align: 'right', render: (r) => r.worklogs_count },
  { key: 'wiki', header: 'Wiki', width: '58px', align: 'right', render: (r) => r.wiki_pages_count },
  {
    key: 'seen',
    header: '最近活跃',
    width: '96px',
    render: (r) => <span className="text-admin-muted">{since(r.last_seen_at)}</span>,
  },
];

const Users: UsersComponent = ({ users, q, page, per, total }) => (
  <>
    <h1 className="mb-3 text-[14.5px] font-semibold tracking-tight">用户</h1>

    <FilterBar
      q={q}
      placeholder="搜索邮箱或名称…"
      right={`${total} 位用户 · 第 ${page} / ${Math.max(1, Math.ceil(total / per))} 页`}
    />

    <DataTable
      columns={COLUMNS}
      rows={users}
      rowKey={(r) => r.id}
      empty="没有匹配的用户"
      pagination={{ page, per, total }}
    />
  </>
);

Users.layout = (page: React.ReactNode) => <AdminLayout>{page}</AdminLayout>;

export default Users;
